module.exports = __webpack_public_path__ + "static/media/bg-2.081d7e01.jpg";